// Recommended upload sizes for every image the admin can change.
// Images are cropped to fill their frame (object-cover), so keep the main subject near the centre.
// "min" sizes trigger a warning in the uploader; the recommended size looks sharp on large and retina screens.
export const IMAGE_SPECS = {
  heroSlide: {
    w: 1920, h: 900, minW: 1600, minH: 750,
    hint: "Wide landscape, 1920 × 900 px (min 1600 × 750). Text sits on the left, so keep the subject toward the right or centre. On phones the centre is shown.",
  },
  product: {
    w: 1200, h: 900, minW: 800, minH: 600,
    hint: "Landscape 4:3, 1200 × 900 px (min 800 × 600). Shown on the product page. A clean, uncluttered background works best.",
  },
  blogCover: {
    w: 1600, h: 900, minW: 1200, minH: 675,
    hint: "Landscape 16:9, 1600 × 900 px (min 1200 × 675). It is cropped to 16:10 on cards, so avoid text near the edges.",
  },
};

// Home / inner-page images edited under Site Content → Hero & Images. Unused legacy slots are intentionally omitted.
export const SECTION_IMAGE_SLOTS = [
  {
    key: "labTech", label: "About section & Quality page photo", where: "Home page “Why choose Novocreste” and the Quality & Compliance page",
    w: 1200, h: 900, minW: 800, minH: 600,
    hint: "Landscape 4:3, 1200 × 900 px (min 800 × 600). Shown at about 600 px wide.",
  },
  {
    key: "pills", label: "About Us page photo", where: "About Us page",
    w: 1200, h: 900, minW: 800, minH: 600,
    hint: "Landscape 4:3, 1200 × 900 px (min 800 × 600). Shown at about 600 px wide.",
  },
  {
    key: "containersSunset", label: "Global reach background", where: "Home page “Serving healthcare worldwide” band (dark overlay on top)",
    w: 1920, h: 1000, minW: 1600, minH: 800,
    hint: "Wide landscape, 1920 × 1000 px (min 1600 × 800). It sits behind text with a dark overlay, so a darker image is fine.",
  },
  {
    key: "portCrane", label: "Services page banner", where: "Services page logistics banner",
    w: 1920, h: 700, minW: 1600, minH: 560,
    hint: "Very wide, 1920 × 700 px (min 1600 × 560). Keep the subject in the middle; the top and bottom are cropped.",
  },
  {
    key: "blister", label: "Default product photo", where: "Used on a product page when that product has no image of its own",
    w: 1200, h: 900, minW: 800, minH: 600,
    hint: "Landscape 4:3, 1200 × 900 px (min 800 × 600).",
  },
];

export const IMAGE_GENERAL_TIP = "Use JPG or WebP for photos (PNG for logos/graphics). Keep each file under about 1 MB for fast loading — compress at squoosh.app if needed.";
